var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcPuntoEnApagado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 229.24 283.46",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#fff;}.cls-2{fill:#636363;}.cls-3{fill:#040006;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "ic-punto-en-apagado") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "_1",
    "data-name": 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "punto_en_apagado"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "fondo",
    className: "cls-1",
    cx: 114.3,
    cy: 114.11,
    r: 105.33
  }), /*#__PURE__*/React.createElement("path", {
    id: "borde",
    className: "cls-2",
    d: "M114.62,17.85a96.77,96.77,0,0,1,68.43,165.2A96.77,96.77,0,1,1,46.2,46.2a96.1,96.1,0,0,1,68.42-28.35m0-17.85A114.62,114.62,0,1,0,229.24,114.62,114.62,114.62,0,0,0,114.62,0Z"
  }), /*#__PURE__*/React.createElement("g", {
    id: "icono"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M107.44,146.24c0,20.69,1.53,22,17.43,23.18v7.47H61.26v-7.47c13-1.15,14.56-2.49,14.56-23.18V83c0-20.7-1.53-22-13.6-23.19V52.35h56c18,0,28.55,2.68,36.21,8.24,8.24,5.94,13.6,14.75,13.6,27.59,0,25.68-19.16,38.9-40.62,40.81-2.1.19-4,.19-5.55.19l-14.37-3.25Zm0-29.89a26.46,26.46,0,0,0,8.24,1.53c6.13,0,18-4.6,18-29.89,0-19.93-10.92-26.06-19.55-26.06-6.32,0-6.7,1-6.7,6.9Z"
  })), /*#__PURE__*/React.createElement("polygon", {
    id: "punta",
    className: "cls-2",
    points: "114.78 283.46 166.93 216.38 62.32 216.38 114.78 283.46"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPuntoEnApagado);
export default __webpack_public_path__ + "static/media/ic-punto-en-apagado.a6c581e986549a283a83f2f47068f181.svg";
export { ForwardRef as ReactComponent };